import sustainableLogo from "../../img/sustainableLogo.svg";
import placeholder_jeans from "../../img/placeholder_jeans.svg";
import customizeIcon from "../../img/customize_icon.svg";
import icon3D from "../../img/3d_icon.svg";
import { Card } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  addProductToSelection,
  removeProductFromSelection,
} from "../../actions/myselection-actions/actions";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Link, useHistory, useParams } from "react-router-dom";
import useWindowWidth from "../../config/useWindowWidth";
import { Draggable } from "react-beautiful-dnd";
import { useEffect, useState } from "react";
import LazyImg from "../Library/LazyImage";
import watermak from "../../img/watermark.png";
import moment from "moment";

const { Meta } = Card;

const ExampleProductCard = ({ index, productPage, product, item }: any) => {
  const [checkedCheck, setCheckedCheck] = useState(false);

  const { user, isAdmin } = useSelector((state: any) => state.auth);
  const selection = useSelector((state: any) => state.selection);
  const folders = useSelector((state: any) => state.folders);
  const dispatch = useDispatch();
  const params: any = useParams();
  const history = useHistory();
  const width = useWindowWidth();

  const colorStroke = () => {
    let sustain = product.labels.find((el: any) => el.name === "SUSTAINABLE");
    let newLabel = product.labels.find((el: any) => el.name === "NEW");
    let favorite = product.labels.find(
      (el: any) => el.name === "DEMCO'S FAVORITE"
    );
    if (product.labels && newLabel) {
      return newLabel.name;
    } else if (product.labels && sustain) {
      return sustain.name;
    } else if (product.labels && favorite) {
      return favorite.name;
    } else {
      return "none";
    }
  };

  useEffect(() => {
    if (productPage) {
      if (folders.selectedProducts.includes(product.id)) {
        setCheckedCheck(true);
      } else {
        setCheckedCheck(false);
      }
    }
  }, [folders.selectedProducts]);

  const draggableProductData = {
    draggableId: `draggable-product${product.id}`,
    parentId: product.idParentFolder,
  };

  const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
    userSelect: "none",
    paddingTop: "10px",
    borderRadius: "10px",
    boxShadow: isDragging ? "10px 0px 20px rgba(0,0,0,0.2)" : "none",
    backgroundColor: isDragging ? "white" : "transparent",
    ...draggableStyle,
  });
  const pathnames = window.location.pathname.split("/");

  return (
    <Draggable
      key={product.id}
      draggableId={JSON.stringify(draggableProductData)}
      index={index}
      disableInteractiveElementBlocking
    >
      {(provided, snapshot) => (
        <div
          // className="one_product_link"
          className="grid-item-product"
          key={index}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style
          )}
        >
          <Link
            to={`/product/details/${params.fabric}/${params.gendre}/${params.category}/${product.name}/${product.id}`}
            style={{ textDecoration: "none" }}
          >
            <Card
              // style={{
              //   width: width < 768 ? "100%" : "18rem",
              //   padding: 15,
              // }}
              bordered={false}
              bodyStyle={{ padding: "0px" }}
              cover={
                <div className={`product_item_new ${colorStroke()} mb-2`}>
                  <LazyImg
                    alt={item.name}
                    style={{
                      position: "absolute",
                      zIndex: 2,
                      opacity: 0.2,
                      objectFit: "cover",
                      width: "100%",
                      height: width > "450px" ? "360px" : "300px",
                    }}
                    src={watermak}
                    thumb={watermak}
                  />
                  <LazyImg
                    className="img-front"
                    alt={item.name}
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: width > "450px" ? "360px" : "300px",
                    }}
                    src={
                      item.main
                        ? process.env.REACT_APP_STORAGE_URL + item.main
                        : placeholder_jeans
                    }
                    thumb={
                      item.main
                        ? process.env.REACT_APP_STORAGE_URL + item.main
                        : placeholder_jeans
                    }
                  />
                  <LazyImg
                    className="img-back"
                    alt={item.name}
                    src={
                      item.onHover
                        ? process.env.REACT_APP_STORAGE_URL + item.onHover
                        : placeholder_jeans
                    }
                    thumb={
                      item.onHover
                        ? process.env.REACT_APP_STORAGE_URL + item.onHover
                        : placeholder_jeans
                    }
                    style={{
                      objectFit: "contain",
                      height: width > "450px" ? "360px" : "300px",
                    }}
                  />
                  {product.labels.find((el: any) => el.name === "NEW") &&
                    // !history.location.pathname.includes("new") &&
                    moment(product.label_new_remove_date).isAfter(
                      moment(new Date())
                    ) && (
                      <div className="new_product_label">
                        <label>NEW </label>
                      </div>
                    )}
                  {product.labels.find((el: any) => el.name === "NEW") &&
                    history.location.pathname.includes("new") && (
                      <div className="new_product_label">
                        <label>NEW</label>
                      </div>
                    )}
                  {product.is_3d === 1 && (
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        background: "rgba(255, 255, 255, 0.2)",
                        position: "absolute",
                        top: "5px",
                        left: "5px",
                      }}
                      className="d-flex align-items-center justify-content-center p-0"
                    >
                      <img
                        src={icon3D}
                        alt="3D product icon"
                        style={{ maxWidth: "80%", height: "auto" }}
                      />
                    </div>
                  )}
                  {productPage && user && !isAdmin && (
                    <div
                    // className="product_card_icons"
                    // style={{
                    //   position: "absolute",
                    //   top: 0,
                    //   width: "100%",
                    //   flexDirection: "row",
                    // }}
                    >
                      <Link
                        to={`/customization/new/${product.id}`}
                        className="customize_icon"
                        style={{
                          position: "absolute",
                          bottom: "5px",
                          right: "2px",
                        }}
                      >
                        <img src={customizeIcon} alt="customize product icon" />
                      </Link>
                      {selection.selectionProducts &&
                      selection.selectionProducts.some(
                        (el: any) => el.id === product.id
                      ) ? (
                        <FontAwesomeIcon
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                          }}
                          icon={
                            selection.productToAddId === product.id &&
                            selection.isLoading
                              ? faSpinner
                              : faHeart
                          }
                          className={
                            selection.productToAddId === product.id &&
                            selection.isLoading
                              ? "favorite_icon favorite_loading"
                              : "favorite_icon favorite_icon_red"
                          }
                          spin={
                            selection.productToAddId === product.id &&
                            selection.isLoading
                          }
                          onClick={(event: any) => {
                            event.preventDefault();
                            event.stopPropagation();
                            dispatch(removeProductFromSelection(product.id));
                          }}
                        />
                      ) : (
                        <FontAwesomeIcon
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                          }}
                          icon={
                            selection.productToAddId === product.id &&
                            selection.isLoading
                              ? faSpinner
                              : farHeart
                          }
                          spin={
                            selection.productToAddId === product.id &&
                            selection.isLoading
                          }
                          className={
                            selection.productToAddId === product.id &&
                            selection.isLoading
                              ? "favorite_icon favorite_loading"
                              : "favorite_icon"
                          }
                          onClick={(event: any) => {
                            event.preventDefault();
                            event.stopPropagation();
                            dispatch(addProductToSelection(product.id));
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              }
            >
              <Meta
                description={
                  productPage &&
                  product && (
                    <div className="d-flex mt-2">
                      <div className="labels_list">
                        {productPage &&
                          product.labels &&
                          product.labels.map((el: any, i: number) =>
                            el.name === "SUSTAINABLE" ? (
                              <div className="sustain_product_label" key={i}>
                                <img src={sustainableLogo} alt="sustainable" />
                                <label>{el.name}</label>
                              </div>
                            ) : !product.labels.find(
                                (el: any) => el.name === "SUSTAINABLE"
                              ) &&
                              !product.labels.find(
                                (el: any) => el.name === "NEW"
                              ) &&
                              product.favorite_by ? (
                              <div className="favorite_product_label" key={i}>
                                <p className="favorite_by">
                                  {product.favorite_by.name}' favorite
                                </p>
                              </div>
                            ) : null
                          )}
                        <div>
                          <h4
                            className="h4_medium mb-0"
                            style={{ fontSize: "1rem" }}
                          >
                            {product.code}{" "}
                            {pathnames[1] == "new" ||
                            pathnames[1] == "collection" ? (
                              <>
                                {product.gender_id == 2 ? (
                                  <>-Women</>
                                ) : product.gender_id == 1 ? (
                                  <>-Men</>
                                ) : product.gender_id == 3 ? (
                                  <>-Unisex</>
                                ) : product.gender_id == 4 ? (
                                  <>-Kids</>
                                ) : product.gender_id == 5 ? (
                                  <>-Boys</>
                                ) : product.gender_id == 6 ? (
                                  <>-Girls</>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </h4>
                          <h4
                            className="h4_medium"
                            style={{ fontWeight: 400, fontSize: "1rem" }}
                          >
                            {product.name}
                          </h4>
                        </div>
                      </div>
                      <div className="d-flex">
                        {productPage &&
                          product &&
                          product.favorite_by &&
                          product.favorite_by.avatar && (
                            <img
                              src={
                                process.env.REACT_APP_STORAGE_URL +
                                product.favorite_by.avatar
                              }
                              className="favorite_by_img"
                            />
                          )}
                      </div>
                    </div>
                  )
                }
              />
            </Card>
          </Link>
        </div>
      )}
    </Draggable>
  );
};

export default ExampleProductCard;
